const MainSearch = class extends HTMLElement {

  constructor() {
    super();

    // Clicking close button
    this.querySelectorAll('.main-search__close').forEach((el) => {
      el.addEventListener('click', (evt) => {
        evt.preventDefault();
        document.body.classList.remove('show-search');
      });
    });

    // Pressing escape key
    const searchInput = this.querySelector('.main-search__input');

    if (searchInput) {
      searchInput.addEventListener('keyup', (evt) => {
        if (evt.key === 'Escape') {
          const closeButton = this.querySelector('.main-search__close');

          if (closeButton) {
            closeButton.dispatchEvent(new Event('click'));
          }
        }
      });
    }

    // Search as you type
    if (this.dataset.quickSearch === 'true') {
      this.initQuickSearch();
    }
  }

  initQuickSearch() {

    const searchInput = this.querySelector('.main-search__input');

    if (!searchInput) return;

    const searchTimeoutThrottle = 500;
    const resultLimit = 8;
    const includeMeta = this.dataset.quickSearchMeta === 'true';

    let searchTimeoutID = -1;
    let searchAbortController = null;

    const handleInputChange = () => {

      const resultsBox = this.querySelector('.main-search__results');

      if (!resultsBox) return;

      const valueToSearch = searchInput.value.trim();

      this.classList.toggle(
        'main-search--has-input',
        valueToSearch.length > 0
      );

      if (
        valueToSearch.length &&
        valueToSearch !== this.oldSearchValue
      ) {

        this.oldSearchValue = valueToSearch;

        if (searchAbortController !== null) {
          searchAbortController.abort();
          searchAbortController = null;
        }

        clearTimeout(searchTimeoutID);

        const form = searchInput.closest('form');

        const linkURL = new URL(
          form.action,
          window.location.origin
        );

        const formParams = new URLSearchParams(
          new FormData(form)
        );

        formParams.forEach((value, key) => {
          linkURL.searchParams.set(key, value);
        });

        this.classList.remove(
          'main-search--has-results',
          'main-search--results-on-multiple-lines',
          'main-search--no-results'
        );

        this.classList.add('main-search--loading');

        if (!this.querySelector('.main-search__results-spinner')) {

          resultsBox.innerHTML =
            '<div class="main-search__results-spinner">' +
              '<div class="loading-spinner"></div>' +
            '</div>';

        }

        searchTimeoutID = setTimeout(() => {

          searchAbortController = new AbortController();

          let ajaxUrl;

          if (theme.Shopify.features.predictiveSearch) {

            ajaxUrl = new URL(
              theme.routes.base + theme.routes.predictiveSearch,
              window.location.origin
            );

            ajaxUrl.searchParams.set(
              'q',
              valueToSearch
            );

            ajaxUrl.searchParams.set(
              'section_id',
              'predictive-search'
            );

            ajaxUrl.searchParams.set(
              'resources[type]',
              'product'
            );

            ajaxUrl.searchParams.set(
              'resources[limit]',
              resultLimit
            );

            ajaxUrl.searchParams.set(
              'resources[options][fields]',
              includeMeta
                ? 'title,product_type,variants.title,vendor,tag,variants.sku'
                : 'title,product_type,variants.title,vendor'
            );

          } else {

            ajaxUrl = new URL(linkURL);

            ajaxUrl.searchParams.set(
              'section_id',
              'main-search'
            );

          }

          fetch(
            ajaxUrl,
            {
              method: 'get',
              signal: searchAbortController.signal
            }
          )

            .then((response) => {

              if (!response.ok) {
                throw new Error(
                  `HTTP error! Status: ${response.status}`
                );
              }

              return response.text();

            })

            .then((response) => {

              const template =
                document.createElement('template');

              template.innerHTML = response;

              let resultsList = null;

              if (theme.Shopify.features.predictiveSearch) {

                resultsList =
                  template.content.querySelector(
                    '.product-grid'
                  );

              } else {

                resultsList =
                  template.content.querySelector(
                    '.section-search-template .product-grid'
                  );

              }

              searchAbortController = null;

              this.classList.remove(
                'main-search--has-results',
                'main-search--results-on-multiple-lines',
                'main-search--no-results'
              );

              resultsBox.innerHTML = '';

              if (!resultsList) {

                this.classList.remove(
                  'main-search--loading'
                );

                this.classList.add(
                  'main-search--no-results'
                );

                const emptyMessage =
                  document.createElement('div');

                emptyMessage.className =
                  'main-search__empty-message';

                emptyMessage.innerHTML =
                  theme.strings.generalSearchNoResultsWithoutTerms;

                resultsBox.appendChild(
                  emptyMessage
                );

                return;
              }

              const resultsProducts =
                document.createElement('div');

              resultsProducts.className =
                'main-search__results__products collection-listing';

              resultsProducts.innerHTML =
                '<div></div>';

              resultsProducts.firstElementChild.className =
                resultsList.className;

              resultsList
                .querySelectorAll(
                  '.product-block:not(.collection-block):not(.page-block)'
                )
                .forEach((block, index) => {

                  if (index < resultLimit) {

                    block.classList.add(
                      'main-search-result'
                    );

                    block
                      .querySelectorAll(
                        '.btn.quickbuy-toggle'
                      )
                      .forEach((el) => {
                        el.remove();
                      });

                    block
                      .querySelectorAll(
                        '.quickbuy-toggle'
                      )
                      .forEach((el) => {
                        el.classList.remove(
                          'quickbuy-toggle'
                        );
                      });

                    resultsProducts
                      .firstElementChild
                      .appendChild(block);

                  }

                });

              this.classList.remove(
                'main-search--loading'
              );

              const areProducts =
                !!resultsProducts.querySelector(
                  '.main-search-result'
                );

              if (areProducts) {

                this.classList.add(
                  'main-search--has-results'
                );

                this.classList.toggle(
                  'main-search--results-on-multiple-lines',
                  resultsProducts.querySelectorAll(
                    '.product-block'
                  ).length > 4
                );

                resultsBox.appendChild(
                  resultsProducts
                );

                const allLink =
                  document.createElement('a');

                allLink.className =
                  'main-search__results-all-link btn btn--secondary';

                allLink.href =
                  linkURL.toString();

                allLink.innerHTML =
                  theme.strings.generalSearchViewAll;

                resultsBox.appendChild(
                  allLink
                );

              } else {

                this.classList.add(
                  'main-search--no-results'
                );

                const emptyMessage =
                  document.createElement('div');

                emptyMessage.className =
                  'main-search__empty-message';

                emptyMessage.innerHTML =
                  theme.strings.generalSearchNoResultsWithoutTerms;

                resultsBox.appendChild(
                  emptyMessage
                );

              }

            })

            .catch((error) => {

              if (error.name === 'AbortError') {
                return;
              }

              console.error(
                'Main search error:',
                error
              );

              this.classList.remove(
                'main-search--loading'
              );

            });

        }, searchTimeoutThrottle);

      } else if (!valueToSearch.length) {

        this.oldSearchValue = '';

        this.classList.remove(
          'main-search--has-input'
        );

        if (searchAbortController !== null) {

          searchAbortController.abort();
          searchAbortController = null;

        }

        clearTimeout(searchTimeoutID);

        this.classList.remove(
          'main-search--has-results',
          'main-search--results-on-multiple-lines',
          'main-search--loading',
          'main-search--no-results'
        );

        resultsBox.innerHTML = '';

      }

    };

    searchInput.addEventListener(
      'input',
      handleInputChange
    );

  }

};


if (!customElements.get('main-search')) {
  customElements.define(
    'main-search',
    MainSearch
  );
}



/* =========================================================
   DESKTOP HEADER LIVE SEARCH
   ========================================================= */

const HeaderLiveSearch =
class extends HTMLElement {

  constructor() {

    super();

    this.searchInput =
      this.querySelector(
        '.header-live-search__input'
      );

    this.resultsBox =
      this.querySelector(
        '.header-live-search__results'
      );

    this.dropdown =
      this.querySelector(
        '.header-live-search__dropdown'
      );

    this.form =
      this.querySelector(
        '.header-live-search__form'
      );

    if (
      !this.searchInput ||
      !this.resultsBox ||
      !this.dropdown ||
      !this.form
    ) {
      return;
    }

    this.searchTimeoutID = null;

    this.searchAbortController = null;

    this.oldSearchValue = '';

    this.resultLimit = 8;

    this.includeMeta =
      this.dataset.quickSearchMeta === 'true';

    this.init();

  }


  init() {

    this.searchInput.addEventListener(
      'input',
      () => {
        this.handleInput();
      }
    );


    this.searchInput.addEventListener(
      'focus',
      () => {

        if (
          this.searchInput.value.trim().length &&
          this.resultsBox.children.length
        ) {

          this.openDropdown();

        }

      }
    );


    this.searchInput.addEventListener(
      'keydown',
      (event) => {

        if (event.key === 'Escape') {

          this.closeDropdown();

          this.searchInput.blur();

        }

      }
    );


    document.addEventListener(
      'click',
      (event) => {

        if (!this.contains(event.target)) {
          this.closeDropdown();
        }

      }
    );

  }


  handleInput() {

    const valueToSearch =
      this.searchInput.value.trim();

    if (!valueToSearch.length) {

      this.oldSearchValue = '';

      this.abortCurrentSearch();

      this.resultsBox.innerHTML = '';

      this.classList.remove(
        'header-live-search--loading',
        'header-live-search--has-results',
        'header-live-search--no-results'
      );

      this.closeDropdown();

      return;

    }


    if (
      valueToSearch ===
      this.oldSearchValue
    ) {
      return;
    }


    this.oldSearchValue =
      valueToSearch;


    this.abortCurrentSearch();


    clearTimeout(
      this.searchTimeoutID
    );


    this.classList.remove(
      'header-live-search--has-results',
      'header-live-search--no-results'
    );


    this.classList.add(
      'header-live-search--loading'
    );


    this.openDropdown();


    this.resultsBox.innerHTML = `
      <div class="header-live-search__spinner">
        <div class="loading-spinner"></div>
      </div>
    `;


    this.searchTimeoutID =
      setTimeout(
        () => {

          this.performSearch(
            valueToSearch
          );

        },
        350
      );

  }


  performSearch(valueToSearch) {

    this.searchAbortController =
      new AbortController();


    const linkURL =
      new URL(
        this.form.action,
        window.location.origin
      );


    const formParams =
      new URLSearchParams(
        new FormData(this.form)
      );


    formParams.forEach(
      (value, key) => {

        linkURL.searchParams.set(
          key,
          value
        );

      }
    );


    let ajaxUrl;


    if (
      theme.Shopify.features
        .predictiveSearch
    ) {

      ajaxUrl =
        new URL(
          theme.routes.base +
          theme.routes.predictiveSearch,
          window.location.origin
        );


      ajaxUrl.searchParams.set(
        'q',
        valueToSearch
      );


      ajaxUrl.searchParams.set(
        'section_id',
        'predictive-search'
      );


      /*
       * PRODUCT ONLY
       */
      ajaxUrl.searchParams.set(
        'resources[type]',
        'product'
      );


      ajaxUrl.searchParams.set(
        'resources[limit]',
        this.resultLimit
      );


      ajaxUrl.searchParams.set(
        'resources[options][fields]',
        this.includeMeta
          ? 'title,product_type,variants.title,vendor,tag,variants.sku'
          : 'title,product_type,variants.title,vendor'
      );

    } else {

      ajaxUrl =
        new URL(linkURL);

      ajaxUrl.searchParams.set(
        'section_id',
        'main-search'
      );

    }


    fetch(
      ajaxUrl,
      {
        method: 'get',
        signal:
          this.searchAbortController.signal
      }
    )

      .then((response) => {

        if (!response.ok) {

          throw new Error(
            `HTTP error! Status: ${response.status}`
          );

        }

        return response.text();

      })

      .then((response) => {

        this.searchAbortController =
          null;


        /*
         * Ignore stale responses
         */
        if (
          this.searchInput.value.trim() !==
          valueToSearch
        ) {
          return;
        }


        const template =
          document.createElement(
            'template'
          );


        template.innerHTML =
          response;


        let resultsList;


        if (
          theme.Shopify.features
            .predictiveSearch
        ) {

          resultsList =
            template.content.querySelector(
              '.product-grid'
            );

        } else {

          resultsList =
            template.content.querySelector(
              '.section-search-template .product-grid'
            );

        }


        this.renderResults(
          resultsList,
          linkURL
        );

      })

      .catch((error) => {

        if (
          error.name ===
          'AbortError'
        ) {
          return;
        }


        console.error(
          'Header live search error:',
          error
        );


        this.classList.remove(
          'header-live-search--loading'
        );


        this.renderNoResults();

      });

  }


  renderResults(
    resultsList,
    linkURL
  ) {

    this.classList.remove(
      'header-live-search--loading',
      'header-live-search--has-results',
      'header-live-search--no-results'
    );


    this.resultsBox.innerHTML = '';


    if (!resultsList) {

      this.renderNoResults();

      return;

    }


    const resultsProducts =
      document.createElement(
        'div'
      );


    resultsProducts.className =
      'header-live-search__products collection-listing';


    resultsProducts.innerHTML =
      '<div></div>';


    resultsProducts
      .firstElementChild
      .className =
        resultsList.className;


    const products =
      resultsList.querySelectorAll(
        '.product-block:not(.collection-block):not(.page-block)'
      );


    products.forEach(
      (block, index) => {

        if (
          index >=
          this.resultLimit
        ) {
          return;
        }


        block.classList.add(
          'main-search-result'
        );


        block
          .querySelectorAll(
            '.btn.quickbuy-toggle'
          )
          .forEach(
            (element) => {

              element.remove();

            }
          );


        block
          .querySelectorAll(
            '.quickbuy-toggle'
          )
          .forEach(
            (element) => {

              element.classList.remove(
                'quickbuy-toggle'
              );

            }
          );


        resultsProducts
          .firstElementChild
          .appendChild(block);

      }
    );


    const hasProducts =
      !!resultsProducts.querySelector(
        '.main-search-result'
      );


    if (!hasProducts) {

      this.renderNoResults();

      return;

    }


    this.resultsBox.appendChild(
      resultsProducts
    );


    const allLink =
      document.createElement(
        'a'
      );


    allLink.className =
      'header-live-search__view-all btn btn--secondary';


    allLink.href =
      linkURL.toString();


    allLink.innerHTML =
      theme.strings
        .generalSearchViewAll;


    this.resultsBox.appendChild(
      allLink
    );


    this.classList.add(
      'header-live-search--has-results'
    );


    this.openDropdown();

  }


  renderNoResults() {

    this.classList.remove(
      'header-live-search--loading',
      'header-live-search--has-results'
    );


    this.classList.add(
      'header-live-search--no-results'
    );


    this.resultsBox.innerHTML = `
      <div class="header-live-search__empty">
        ${
          theme.strings
            .generalSearchNoResultsWithoutTerms
        }
      </div>
    `;


    this.openDropdown();

  }


  abortCurrentSearch() {

    if (
      this.searchAbortController
    ) {

      this.searchAbortController
        .abort();

      this.searchAbortController =
        null;

    }

  }


  openDropdown() {

    this.classList.add(
      'header-live-search--open'
    );

  }


  closeDropdown() {

    this.classList.remove(
      'header-live-search--open'
    );

  }

};


if (
  !customElements.get(
    'header-live-search'
  )
) {

  customElements.define(
    'header-live-search',
    HeaderLiveSearch
  );

}